import { Phone, MessageCircle, CalendarCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Button } from "@/components/ui/button";
import { useAppointment } from "@/context/AppointmentContext";
import { whatsappHref, callHref } from "@/data/site";

export function CTABanner() {
  const { openDialog } = useAppointment();
  return (
    <section data-testid="cta-banner" className="py-16 sm:py-20">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl bg-brand-navy px-7 sm:px-14 py-14 text-center">
            <div className="absolute inset-0 grain opacity-30" />
            <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-brand/30 blur-3xl" />
            <div className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-brand-sky/20 blur-3xl" />
            <div className="relative">
              <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light text-white text-balance">
                Need a Diagnostic Test?
              </h2>
              <p className="mt-4 text-white/75 max-w-xl mx-auto text-base">
                Book your appointment today or reach out instantly. Accurate reports, quick turnaround, caring staff.
              </p>
              <div className="mt-8 flex flex-wrap justify-center gap-3">
                <Button data-testid="cta-book-btn" onClick={() => openDialog()} className="h-12 rounded-full bg-booking hover:bg-booking-dark px-7 gap-2 shadow-lg shadow-booking/30">
                  <CalendarCheck className="h-5 w-5" /> Book Appointment
                </Button>
                <a href={callHref} data-testid="cta-call-btn">
                  <Button variant="outline" className="h-12 rounded-full px-7 gap-2 bg-white/5 border-white/25 text-white hover:bg-white hover:text-brand-navy">
                    <Phone className="h-5 w-5" /> Call Now
                  </Button>
                </a>
                <a href={whatsappHref()} target="_blank" rel="noopener noreferrer" data-testid="cta-whatsapp-btn">
                  <Button variant="outline" className="h-12 rounded-full px-7 gap-2 bg-[#25D366] border-[#25D366] text-white hover:bg-[#1faa55] hover:border-[#1faa55]">
                    <MessageCircle className="h-5 w-5" /> WhatsApp Now
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function EmergencyBanner() {
  return (
    <div data-testid="emergency-banner" className="bg-brand text-white text-sm">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-2.5 flex items-center justify-center gap-2 text-center">
        <Phone className="h-4 w-4 shrink-0" />
        <span className="font-medium">Same-day reports available · Call us at <a href={callHref} className="font-bold underline underline-offset-2">9044159292</a></span>
      </div>
    </div>
  );
}
